export default __webpack_public_path__ + "static/media/winner_8.3b65cd6f.jpg";